import { render } from "./RichTextInput.vue?vue&type=template&id=889342be&scoped=true"
import script from "./RichTextInput.vue?vue&type=script&lang=js"
export * from "./RichTextInput.vue?vue&type=script&lang=js"

import "./RichTextInput.vue?vue&type=style&index=0&id=889342be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889342be"]])

export default __exports__